<template>
  <v-container id="contact" class="mb-15">
    <v-row class="align-center">
      <v-col
        v-if="!smAndDown"
        cols="12"
        lg="6"
        class="d-flex justify-center pb-0"
      >
        <figure>
          <v-img
            class="contact-img"
            :src="this.files + item.img_contact"
          ></v-img>
        </figure>
      </v-col>
      <v-col cols="12" lg="5">
        <TitleWidget :align="'left'">Fale conosco</TitleWidget>
        <div>Envie uma mensagem no formulário abaixo</div>
        <ContactForm
          class="mt-5"
          :action="server + formAction"
          response-to="/contato/obrigado"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";
import ContactForm from "../forms/ContactForm.vue";

export default {
  data: () => ({
    formAction: "/rest/email/contact-us",
  }),
  computed: {
    item() {
      return this.$rest("informations").item;
    },
    smAndDown() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  created() {
    this.$rest("informations").get({
      save: (state, data) => (state.item = data),
    });
  },
  components: {
    TitleWidget,
    ContactForm,
  },
};
</script>

<style scoped lang="scss">
#contact {
  background: var(--v-grey-base);
  margin-top: 100px;
  border-radius: 100px;
  .contact-img {
    width: 440px;
    max-width: 100%;
    margin-top: -100px;
  }

  @media (max-width: 960px) {
    border-radius: 20px;
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
</style>
